import React, { useState, useRef, useEffect } from 'react';

interface AddExampleSeparatorProps {
  onAdd: (text: string) => void;
  disabled?: boolean;
  disabledTooltip?: string;
}

const AddExampleSeparator: React.FC<AddExampleSeparatorProps> = ({ onAdd, disabled = false, disabledTooltip }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isEditing) {
      const id = requestAnimationFrame(() => inputRef.current?.focus());
      return () => cancelAnimationFrame(id);
    }
  }, [isEditing]);

  const handleSubmit = () => {
    const value = text.trim();
    if (!value) return;
    onAdd(value);
    setText('');
    setIsEditing(false);
  };

  if (!isEditing) {
    return (
      <div className="my-4">
        <div className="relative flex items-center justify-center group">
          <div className="w-full h-px bg-gray-200" />
          <button
            onClick={() => { if (!disabled) setIsEditing(true); }}
            className={`absolute -translate-y-1/2 top-1/2 inline-flex items-center justify-center w-6 h-6 transition-colors ${disabled ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 group-hover:text-blue-700'}`}
            title={disabled ? (disabledTooltip || 'add new disabled - change in settings') : 'add new'}
            aria-disabled={disabled}
          >
            <span className={`w-6 h-6 rounded flex items-center justify-center ${disabled ? '' : 'group-hover:ring-2 group-hover:ring-blue-300 group-hover:bg-white'}`}>
              +
            </span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="my-4">
      <div className="flex items-center space-x-2">
        <input
          ref={inputRef}
          type="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') { e.preventDefault(); handleSubmit(); }
            else if (e.key === 'Escape') { e.preventDefault(); setIsEditing(false); setText(''); }
          }}
          placeholder="Type new example and press Enter"
          className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          onClick={handleSubmit}
          disabled={!text.trim()}
          className="px-3 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
        >
          Add
        </button>
        <button
          onClick={() => { setIsEditing(false); setText(''); }}
          className="px-3 py-2 text-sm bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default AddExampleSeparator;


